import { RadioButton, Typography } from '@weareopenr/component-library';
import classnames from 'classnames/bind';
import { FieldValues, UseFormRegister } from 'react-hook-form';
import styles from './RadioButtonList.module.scss';

const cx = classnames.bind(styles);

export interface RadioButtonListOption {
  value: string;
  label: string;
  description?: string;
}

interface RadioButtonListProps {
  name: string;
  options: RadioButtonListOption[];
  register?: UseFormRegister<FieldValues>;
  disabled?: boolean;
}

export const RadioButtonList = ({ name, options, register, disabled = false }: RadioButtonListProps) => (
  <>
    {options.map(({ value, label, description }) => {
      return (
        <RadioButton key={value} name={name} value={value} register={register} disabled={disabled}>
          <div className={cx('label', { disabled })}>
            <Typography size="medium" weight="semi-bold">
              {label}
            </Typography>
            {description && <Typography size="medium">{description}</Typography>}
          </div>
        </RadioButton>
      );
    })}
  </>
);

export default RadioButtonList;
